import { useEffect, useState } from 'react';
import { useUIStore } from '@/state/useUIStore';
import { useInventoryStore } from '@/state/useInventoryStore';
import './Shop.css';

// Shop items with UUIDs matching database
const SHOP_ITEMS = [
  { id: '00000000-0000-0000-0000-000000000001', name: 'War Banner', type: 'banner', price: 499, preview: '\u2694' },
  { id: '00000000-0000-0000-0000-000000000002', name: 'Royal Standard', type: 'banner', price: 799, preview: '\u{1F451}' },
  { id: '00000000-0000-0000-0000-000000000003', name: 'Dragon Sigil', type: 'banner', price: 299, preview: '\u{1F432}' },
  { id: '00000000-0000-0000-0000-000000000004', name: 'Golden Eagle', type: 'banner', price: 599, preview: '\u{1F985}' },
  { id: '00000000-0000-0000-0000-000000000005', name: 'Iron Wolf', type: 'banner', price: 999, preview: '\u{1F43A}' },
  { id: '00000000-0000-0000-0000-000000000006', name: 'Lion Crest', type: 'banner', price: 399, preview: '\u{1F981}' },
];

export function Shop() {
  const { closeShop, showShop } = useUIStore();
  const { items, fetchInventory, startCheckout } = useInventoryStore();
  const [purchasing, setPurchasing] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  // Fetch inventory when shop opens
  useEffect(() => {
    if (showShop) {
      fetchInventory();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showShop]);

  if (!showShop) return null;

  // Check if item is owned
  const isOwned = (itemId: string) => items.some(i => i.itemId === itemId && i.owned);

  const handlePurchase = async (itemId: string) => {
    setPurchasing(itemId);
    setError(null);

    try {
      const checkoutUrl = await startCheckout(itemId);
      // Redirect to Stripe Checkout
      window.location.href = checkoutUrl;
    } catch (err) {
      setError((err as Error).message);
      setPurchasing(null);
    }
  };

  return (
    <div className="shop-overlay" onClick={closeShop}>
      <div className="shop-modal" onClick={(e) => e.stopPropagation()}>
        <header className="shop-header">
          <h2>THE ARMORY</h2>
          <button className="close-btn" onClick={closeShop}>&times;</button>
        </header>

        <div className="shop-content">
          {error && <div className="shop-error">{error}</div>}

          <div className="shop-grid">
            {SHOP_ITEMS.map((item) => {
              const owned = isOwned(item.id);
              const isPurchasing = purchasing === item.id;

              return (
                <div key={item.id} className={`shop-item ${owned ? 'owned' : ''}`}>
                  <div className="item-preview">
                    <span className="preview-emoji">{item.preview}</span>
                  </div>
                  <div className="item-info">
                    <h3 className="item-name">{item.name}</h3>
                    <span className="item-type">{item.type}</span>
                  </div>
                  <div className="item-action">
                    {owned ? (
                      <span className="owned-badge">CLAIMED</span>
                    ) : (
                      <button
                        className="buy-btn"
                        onClick={() => handlePurchase(item.id)}
                        disabled={isPurchasing}
                      >
                        {isPurchasing ? (
                          <span className="spinner" />
                        ) : (
                          <span className="price">${(item.price / 100).toFixed(2)}</span>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <footer className="shop-footer">
          <p className="shop-note">
            Purchases are processed securely through the Royal Treasury.
          </p>
        </footer>
      </div>
    </div>
  );
}
